module.exports = __webpack_public_path__ + "public/img/企业文化CULTURE_CN.8c1784ab.png";